export default __webpack_public_path__ + "static/media/radio-checked-red.5f8a6224.svg";